<template>
  <div class="add-new-case">
    <Modal v-model="addNewCase" width="950" @on-visible-change="isClose" :mask-closable="false">
      <PatientInfo ref="patientInfo" style="margin-top: 10px" @caseInfoMessage="getCaseInfoMessage" @patientInfo="getPatientInfo"></PatientInfo>
      <CaseInfo :caseInfoMesage="caseInfoMesage" ref="caseInfo" style="margin-top: 30px" @caseInfo="getCaseInfo"></CaseInfo>
      <div slot="footer">
        <Button type="default" size="large"  style="width: 75px" @click="addNewCaseInfo('0')">{{$t('addNewCase.consummation')}}</Button>
        <Button type="primary" size="large"  style="width: 150px" @click="addNewCaseInfo('1')">{{$t('addNewCase.barcodePrinting')}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import PatientInfo from './PatientInfo'
import CaseInfo from './CaseInfo'
import {formatDate} from '../../../../utils/date'
export default {
  name: 'AddNewCase',
  components: {PatientInfo, CaseInfo, formatDate},
  data () {
    return {
      $vue: '',
      addNewCase: true,
      // 从二维码获取的送检医生和送检部门
      caseInfoMesage: [],
      patientInfo: '',
      caseInfo: '',
      qrCodecaseId: ''
    }
  },
  methods: {
    // 从二维码获取的送检医生和送检部门
    getCaseInfoMessage (message) {
      this.caseInfoMesage = message
    },
    // 获取到病人信息
    getPatientInfo (patientInfo) {
      // todo  是否校验成功
      this.patientInfo = patientInfo
    },
    // 获取到病例信息
    getCaseInfo (caseInfo) {
      // todo  是否校验成功
      this.caseInfo = caseInfo
    },
    // 添加新的病例信息
    addNewCaseInfo (type) {
      this.$refs.caseInfo.searchsendDoctor()
      this.$refs.caseInfo.searchsampleType()
      this.$refs.patientInfo.submitPatientInfo()
      this.$refs.caseInfo.submitCaseInfo()
      if (this.patientInfo !== '' && this.caseInfo !== '') {
        let caseTypeAndSlideDyeType = this.getslideDyeType()
        let caseType = caseTypeAndSlideDyeType.caseType // 获取病例类型
        let slideDyeType = caseTypeAndSlideDyeType.slideDyeType // 获取染色类型
        let sendDate = this.caseInfo.sendDate
        this.deleteBase64() // 将取材图像中的base64置空
        let params = new URLSearchParams()
        params.append('type', type)
        params.append('caseType', caseType)
        params.append('slideDyeType', slideDyeType) // 染色类型
        if (sendDate) {
          params.append('sendDate', formatDate(sendDate, 'yyyy-MM-dd hh:mm:ss')) // 送检时间
        }
        params.append('patientInfoForm', JSON.stringify(this.patientInfo)) // 病人信息
        params.append('caseInfoForm', JSON.stringify(this.caseInfo)) // 病例信息
        if (this.patientInfo.patBirthday) {
          params.append('patBirthday', formatDate(this.patientInfo.patBirthday, 'yyyy-MM-dd')) // 出生日期
        }
        params.append('userInfoId', localStorage.getItem('userId' + localStorage.getItem('userName')))
        params.append('laboratoryId', localStorage.getItem('laboratoryId'))
        this.$http.post(this.$vue.getData('ADD_NEW_CASE_URL'), params).then((suc) => {
          if (suc.data.result === '1' && type === '1') { // 添加成功并打印二维码
            this.qrCodecaseId = suc.data.data
            this.printCaseQrCode(this.qrCodecaseId)
            this.addNewCase = false
          } else if (suc.data.result === '1') { // 添加成功
            this.addNewCase = false
          }
        })
      } else {
        this.$Message.error(this.$t('addNewCase.addCaseTip'))
      }
    },
    // 将取材图像中的base64置空
    deleteBase64 () {
      // 删除取材信息中的base64
      let samples = this.caseInfo.samples
      for (var i = 0; i < samples.length; i++) {
        let uploadList = samples[i].uploadList
        for (var j = 0; j < uploadList.length; j++) {
          uploadList[j].material_base64 = ''
        }
      }
    },
    // 打印病例二维码
    async printCaseQrCode (caseId) {
      let params = new URLSearchParams()
      params.append('caseId', caseId)
      let suc = await this.$http.post(this.$vue.getData('PRINT_SLIDE_QRCODE_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        let IsMoreSlides = data.length > 1 ? 'true' : 'false'
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          let code = ''
          if (IsMoreSlides) {
            code = item.slide_code
          } else {
            code = item.pathology_id
          }
          let qrcode = '@' + item.slide_id
          try {
            window.HandleEvent('print', code, qrcode)
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
        }
      }
      console.log(suc)
    },
    /**
     * @method       getslideDyeType
     * @author       dongkuoji
     * @description  方法描述:获取分析方法，以及病理类型（细胞/组织)
     * @return      caseTypeAndDyeType
     * @date        2018/6/25 9:45
     */
    getslideDyeType () {
      let pathologyType = this.caseInfo.samples[0].pathologyType // 获取分析类型
      let slideDyeType = -1 // 染色类型
      let caseType = -1 // 病理类型
      switch (pathologyType) {
        case '1':
          slideDyeType = 1
          caseType = 1
          break
        case '2':
        case '9':
          slideDyeType = 2
          caseType = 1
          break
        case '3':
          slideDyeType = 3
          caseType = 1
          break
        case '5':
          slideDyeType = 5
          caseType = 1
          break
        case '4':
        case '6':
        case '7':
          slideDyeType = 4
          caseType = 2
          break
        case '8':
          slideDyeType = 7
          caseType = 1
          break
      }
      let caseTypeAndSlideDyeType = {'slideDyeType': slideDyeType, 'caseType': caseType}
      return caseTypeAndSlideDyeType
    },
    // 关闭模态框
    closeModal () {
      this.addNewCase = false
    },
    // 如果已经关闭，通知父组件，已经关闭了,关闭参数为false
    isClose (state) {
      if (!state) {
        this.$emit('isClosed')
      }
    }
  },
  beforeMount () {
    this.$vue = this
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  .add-new-case {
    width 90px
    position absolute
    left 20px
    top 0px
  }

  .ivu-form .ivu-form-item-label{
    font-size 15px
  }
  .ivu-input{
    font-size 14px
  }
  .ivu-form .ivu-row{
    top 13px
  }
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/addCase/AddNewCase.vue